import styled from 'styled-components';

export const Container = styled.div`
  font-family: 'Inter';

  .p-paginator,
  .p-paginator * {
    font-family: 'Inter';
  }

  .p-paginator .p-paginator-page {
    font-size: 12px;
  }
`;

export const SearchPanel = styled.div`
  padding-top: 16px;
`;

export const FilterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

export const FilterField = styled.div`
  width: 350px;
  .p-inputtext,
  .p-dropdown {
    width: 100%;
  }
`;

export const SearchFilterField = styled(FilterField)`
  width: 358px;
`;
